import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import utc from 'dayjs/plugin/utc'

dayjs.extend(LocalizedFormat)
dayjs.extend(utc)

// The backend sends UTC timestamps with no offset, which dayjs would otherwise read as local time (SME-1020).
export function parseServerDate(date: string | Date | number) {
  return dayjs.utc(date).local()
}

export function browserTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export function formatDate(date: string | Date | number, opts?: { format?: string; fallback?: string; utc?: boolean }) {
  const { format = 'lll', fallback, utc: useUtc = false } = opts ?? {}

  const dateMoment = useUtc ? dayjs.utc(date) : parseServerDate(date)

  if (!date || !dateMoment.isValid()) return fallback ?? null

  return dateMoment.format(format)
}
